module.exports = __webpack_public_path__ + "img/en.de7f8c35.svg";